// Display-only copy over the existing backend state; never changes action/read/link data.
const genericContexts = new Set(["service", "dein gespräch", "your conversation", "your thread"]);

export function playerCommunicationTime(value, timezone, lang, at = new Date()) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "–";
  const locale = lang === "de" ? "de-DE" : "en-GB";
  const day = new Intl.DateTimeFormat("en-CA", { timeZone: timezone || "UTC", dateStyle: "short" });
  const sameDay = day.format(date) === day.format(at);
  return new Intl.DateTimeFormat(locale, {
    timeZone: timezone || "UTC", hour: "2-digit", minute: "2-digit",
    ...(!sameDay ? { day: "numeric", month: "short", year: "numeric" } : {}),
  }).format(date);
}

export function playerNotificationDisplay(row, t) {
  const titleKeys = {
    service_approval: "notificationServiceResponse", no_player_action: "notificationServiceResponse",
    feedback_due: row.kind === "match_feedback_due" ? "notificationMatchFeedback" : "notificationFeedback",
    no_longer_due: row.kind === "match_feedback_due" ? "notificationMatchFeedback" : "notificationFeedback",
    feedback_saved: "notificationFeedbackRecorded", request_resolved: "notificationConversation",
    response_sent: "notificationReply", response_requested: "notificationCareReply",
    unavailable: "notificationUnavailable", review_closed: "notificationMealReview", plan_update: "notificationPlanUpdate",
  };
  const status = row.action_status || "information";
  const closed = status === "completed" && ["unavailable", "no_longer_due", "no_player_action", "review_closed"].includes(row.state_reason);
  const fallbackTitle = titleKeys[row.state_reason] ? t(titleKeys[row.state_reason])
    : /nicht mehr offen|no longer (open|outstanding)/i.test(row.title || "") ? t("notificationClosed") : row.title;
  const title = (row.presentation_title || "").trim() || fallbackTitle;
  const body = (row.message_preview || row.body || "").trim();
  const context = !body || genericContexts.has(body.toLowerCase()) || body.toLowerCase() === (title || "").toLowerCase()
    || /nicht mehr offen|no longer (open|outstanding)/i.test(body) ? null : body;
  return { title, context, statusLabel: t(closed ? "notificationClosed" : `notificationState_${status}`) };
}
